import { ApiError } from "../lib/api";
import { t as msg } from "../lib/i18n";

/** Recovery controls reflect the failed request; retrying here never repeats a mutation. */
export function RequestFailure({ error, retry, signIn }: {
  error: Error; retry?: () => void; signIn?: () => void;
}) {
  const recovery = error instanceof ApiError ? error.recovery : "none";
  return <div className="notice" role="alert">
    <p className="error">{error.message}</p>
    <div className="inline-links">
      {retry && (recovery === "retry" || recovery === "refresh") && <button className="button secondary" onClick={retry}>{msg("Try again")}</button>}
      {signIn && (recovery === "sign_in" || recovery === "account") && <button className="button" onClick={signIn}>{msg(recovery === "account" ? "Use another account" : "Sign in to open")}</button>}
    </div>
  </div>;
}
